/**
 * Lightweight bus for "New reward" toasts after a Reward socket push.
 * Consumed by the shell banner host — not a general toast system.
 */

export interface RewardToast {
  id: number;
  at: number;
}

type Listener = () => void;

let latest: RewardToast | null = null;
let version = 0;
const listeners = new Set<Listener>();

function notify(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function publishNewRewardToast(rewardId: number): void {
  latest = { id: rewardId, at: Date.now() };
  notify();
}

export function getRewardToast(): RewardToast | null {
  return latest;
}

export function getRewardToastVersion(): number {
  return version;
}

export function clearRewardToast(): void {
  if (!latest) return;
  latest = null;
  notify();
}

export function subscribeRewardToast(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
